export const TutorialGifsNotificationStack = {
  flow: 'y',
  childExtends: 'TutorialGifNotification',
  position: 'relative',
  gap: 'X',
  width: 'H2',
  childrenAs: 'state',
  children: [
    {
      key: 'explainCanvas',
      title: 'learn.coach.zoom.title',
      descr: 'learn.coach.canvas.descr',
      src: 'intro.gif',
      docsArticle: '/canvas-and-editor'
    },
    {
      key: 'explainRealtime',
      title: 'learn.coach.realtime.title',
      descr: 'learn.coach.realtime.descr',
      src: 'realtime.gif',
      docsArticle: '/publish'
    },
    {
      key: 'explainEditingAndNav',
      title: 'learn.coach.edit.title',
      descr: 'learn.coach.edit.descr',
      icon: 'double-click.json',
      src: 'editor.gif',
      docsArticle: '/building-in-symbols',
      callback: (el, s) => {
        el.setWindow('explorer', 'onboarding')
      }
    }
  ],
  childProps: {
    ':nth-child(3)': {
      pointerEvents: 'none',
      zIndex: 1,
      opacity: 0.7,
      position: 'absolute',
      transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
    },
    ':nth-child(2)': {
      pointerEvents: 'none',
      zIndex: 2,
      opacity: 0.9,
      position: 'absolute',
      transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
    },
    ':nth-child(1)': {
      position: 'relative',
      zIndex: 3
    }
  }
}
